<template>
  <div class="head-timer">
    <img src="../../assets/img/detail/sale_item.png" class-name="img-100" />
    <timer-text />
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';

  export default {
    computed: {
      ...mapGetters(['leftSecsPre',
        'leftSecsBegin',
        'leftSecsEnd'
      ])
    }
  }
</script>
